import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IceapiService } from 'src/app/services';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DiagramDataModel, DiagramModel } from '../../models';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { BehaviorSubject, debounceTime, distinctUntilChanged, filter } from 'rxjs';

@Component({
    selector: 'app-torquepattern',
    templateUrl: './torquepattern.component.html',
    styleUrls: ['./torquepattern.component.scss'],
    standalone: false
})
export class TorquepatternComponent implements OnInit {
    @Input()
    set diagramInfo(data: DiagramDataModel) {
        if (!this.isSameDiagramInfo(this._diagramInfo, data)) {
            this._diagramInfo = data;
            this.diagramInfo$.next(data);
        }
    }
    get diagramInfo(): DiagramDataModel {
        return this._diagramInfo;
    }

    _diagramInfo: DiagramDataModel;
    diagramItem: DiagramModel;
    private diagramInfo$ = new BehaviorSubject<DiagramDataModel>(null);
    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.diagramInfo$
            .pipe(
                filter((info) => !!info),
                debounceTime(200),
                distinctUntilChanged((prev, curr) => this.isSameDiagramInfo(prev, curr))
            )
            .subscribe((info) => {
                this.getDiagram(info.torqueSequenceName);
            });

        // Listen to global emitter
        this.globalEmittersService.torqueSequencename
            .pipe(
                filter((name) => !!name),
                debounceTime(200),
                distinctUntilChanged()
            )
            .subscribe((name) => {
                this.getDiagram(name);
            });
    }

    // * api call to get the diagram image
    getDiagram(torqueSequenceName) {
        this.iceapi
            .getDiagram('', torqueSequenceName)
            .pipe(
                filter((name) => !!name),
                debounceTime(200),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res.success) {
                    this.diagramItem = res.response;
                    this.cd.detectChanges();
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            });
    }
    // Compare only relevant fields to prevent duplicate calls
    private isSameDiagramInfo(a: DiagramDataModel, b: DiagramDataModel): boolean {
        if (!a || !b) return false;
        return a.torqueSequenceName === b.torqueSequenceName;
    }
}
